import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';

export const LANGUAGES = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'es', label: 'Español', short: 'ES' },
];

const STORAGE_KEY = 'aan_lang';

export function detectLanguage() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
  const nav = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
  return nav.startsWith('es') ? 'es' : 'en';
}

i18next.use(initReactI18next).init({
  lng: detectLanguage(),
  fallbackLng: 'en',
  resources: { en: { translation: {} }, es: { translation: es } },
  keySeparator: false,
  nsSeparator: false,
  returnEmptyString: false,
  initImmediate: false,
  interpolation: { escapeValue: false },
});

// Natural-language keys: English text is the key, so missing keys fall back to English.
export const t = (key, opts) => i18next.t(key, { defaultValue: key, ...opts });
export const getLanguage = () => i18next.language || 'en';

export function setLanguage(code, { reload = true } = {}) {
  if (!LANGUAGES.some((l) => l.code === code)) return;
  localStorage.setItem(STORAGE_KEY, code);
  document.documentElement.lang = code;
  if (reload) window.location.reload();
  else i18next.changeLanguage(code);
}

document.documentElement.lang = getLanguage();

export default i18next;
